
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    ADD_INTEGRATION_GET_INTEGRATIONS_REQUEST,
    ADD_INTEGRATION_REQUEST,
    ADD_INTEGRATION_CEREBRUMX_REQUEST,
    ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_REQUEST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { addIntegrationGetIntegrationsResult, addIntegrationResult, addIntegrationCerebrumXGetFleetsResult } from 'Redux/actions';

export const getAccounts = async (input = '') => {
    try {
        let result = []
        let QUERY = `
        query searchZonarCompanies ($name: String!, $page: Int, $limit: Int) {
            result: searchZonarCompanies (name: $name, page: $page, limit: $limit)
        }`
        result = await clientQuery(QUERY, {
            name: input,
            page: 1,
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);

        if (result?.result) {
            result = JSON.parse(result?.result)
        } else {
            result = []
        }

        return result
    } catch (exc) {
        ExceptionManager(exc, 'Modules/activities/.components/tab/redux/saga', 'searchAuditlogs');
    }
}

function* getIntegrations() {
    try {

        const QUERY = `
        query searchIntegrations ($conditions: [IntegrationSearchInput], $sort: [IntegrationSortInput], $limit: Int, $offset: Int) {
            result: searchIntegrations (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    code
                    name
                    description
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [],
                sort: {
                    field: "name",
                    order: "ASC"
                },
                limit: 20,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(addIntegrationGetIntegrationsResult(data?.result))
        } else {
            yield put(addIntegrationGetIntegrationsResult({ error: true }))
        }

    } catch (exc) {
        yield put(addIntegrationGetIntegrationsResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/addIntegration/redux/saga",
            "getIntegrations",
        )
    }
}

function* addIntegration({ payload }) {
    try {
        let { companyId, reprocessAll, unitIds, startDate, type } = payload
        let QUERY = `
            
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                companyId,
                reprocessAll,
                unitIds,
                startDate,
                type
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(addIntegrationResult({ result: data?.response }))

    } catch (exc) {
        yield put(addIntegrationResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/addIntegration/redux/saga",
            "addIntegration",
        )
    }
}

function* createCompanyIntegration({ payload }) {
    try {
        let { companyId, integrationId, name, fanId, oem, parameters, status, fleetId } = payload

        let QUERY = `
            mutation createCompanyIntegration ($companyId: Int!, $integrationId: Int!, $parameters: AWSJSON, $status: String, $fleetId: String) {
                response: createCompanyIntegration (companyId: $companyId, integrationId: $integrationId, parameters: $parameters, status: $status, fleetId: $fleetId){
                    id
	                companyId
	                integrationId
                    parameters
                    status
                }
            }
        `

        let data = yield call(
            clientMutation,
            QUERY,
            {
                companyId,
                integrationId,
                parameters,
                status,
                fleetId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        //name,
        //fanId,
        //oem

        yield put(addIntegrationResult({ result: data?.response }))

    } catch (exc) {
        yield put(addIntegrationResult({ error: exc }))
        ExceptionManager(exc, "Modules/accounts/.components/addIntegration/redux/saga", "createCompanyIntegration")
    }
}

function* addIntegrationCerebrumXGetFleets() {

    try {
        const QUERY = `
        query getAllFleet {
              result:  getAllFleet {
                    fleetId
                name
                fleetStatus
                fanId
                oems {
                    name
                    consentStatus
                    }
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [],
                sort: {
                    field: "name",
                    order: "ASC"
                },
                limit: 20,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(addIntegrationCerebrumXGetFleetsResult(data?.result))
        } else {
            yield put(addIntegrationCerebrumXGetFleetsResult({ error: true }))
        }
    } catch (exc) {
        yield put(addIntegrationCerebrumXGetFleetsResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/addIntegration/redux/saga",
            "addIntegrationCerebrumXGetFleets",
        )
    }

}

function* watchMethods() {
    yield takeEvery(ADD_INTEGRATION_GET_INTEGRATIONS_REQUEST, getIntegrations);
    yield takeEvery(ADD_INTEGRATION_REQUEST, addIntegration);
    yield takeEvery(ADD_INTEGRATION_CEREBRUMX_REQUEST, createCompanyIntegration);
    yield takeEvery(ADD_INTEGRATION_CEREBRUMX_GET_FLEETS_REQUEST, addIntegrationCerebrumXGetFleets);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}